/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'send': {
    width: 14,
    height: 14,
    viewBox: '0 0 14 14',
    data: '<g><g _fill="#FFF"><path pid="0" d="M0,5.29,11.34,6.81,0,8.32v5.29l15.87-6.8L0,0Z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/send.js